module.exports = __webpack_public_path__ + "static/media/home_tunnel_4.c229028d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_tunnel_4.png
// module id = 115
// module chunks = 0